import Scene from "../js/webgl/Scene";
import { Group, AnimationMixer, LoopOnce } from 'three';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Helper function to calculate closest 90-degree point 
async function LoadedObjectContact() {
    const contact_page = document.querySelector('[data-target="contact_page"]');
    const contact_top = document.querySelector('[data-target="contact_top"]');
    const form_contant = document.querySelector('[data-target="form_contant"]');
    
    

    if (!contact_page) return;

    const contact_scrolldown = document.querySelector('[data-target="contact_scrolldown"]');
    if (contact_scrolldown) {
        contact_scrolldown.addEventListener('click', () => {
            gsap.to(window, {
                duration: 1.5,
                scrollTo: {
                    y: document.querySelector('#ourlocations').offsetTop,
                    autoKill: false
                },
                ease: "power2.out"
            });
        });
    }

    const scene = new Scene();

    // Load object into the scene
    const contactglb = await scene.loadGltf('/wp-content/themes/finbourne/assets/objects/contact.glb');

    const group = new Group();
    group.add(contactglb.scene);  // Add the loaded object to the group
    scene.sceneGroup.add(group);

    // Add camera
    scene.camera = contactglb.cameras[0].clone();
    scene.camera.aspect = scene.container.offsetWidth / scene.container.offsetHeight;
    scene.camera.updateProjectionMatrix();

    // Initial camera zoom setup (1.5x zoom)
    const initialFov = scene.camera.fov;
    const zoomedInitialFov = initialFov / 1.3;  // Initial zoom set to 1.5x
    scene.camera.fov = zoomedInitialFov;
    scene.camera.updateProjectionMatrix();  // Apply the initial 1.5x zoom

    // Camera animations
    scene.mixer = new AnimationMixer(scene.camera);
    const clipAction = scene.mixer.clipAction(contactglb.animations[0]);
    clipAction.setLoop(LoopOnce);
    clipAction.clampWhenFinished = true;
    clipAction.timeScale = 1;  
    scene.clipActions.push(clipAction);

    // Object animations
    const objectMixer = new AnimationMixer(contactglb.scene);
    let objectAction = null;

    if (contactglb.animations.length > 0) {
        objectAction = objectMixer.clipAction(contactglb.animations[0]);
        objectAction.clampWhenFinished = true;
        objectAction.play();   
    }

    // Re-init orbit controls
    scene.orbitControls = scene.createOrbitControls();
    scene.orbitControls.enableRotate = false;
    scene.orbitControls.enableZoom = false;
    scene.orbitControls.enablePan = false;

    // Adjust the object material and light properties
    contactglb.scene.traverse(child => {
        if (child.isMesh) {
            // child.material.transparent = false;
            // child.material.blending = AdditiveBlending;
            // child.material.color.set(0x000000);
            // child.material.opacity = 1;
        }

        if (child.isPointLight) {
            child.intensity = 250;  
        }
        if (child.isSpotLight) {
            child.intensity = 50;  
        }
    });

    // Final zoom setup (for 2.5x zoom)
    const zoomedFov = initialFov / 10;  // 2.5x zoom target


    const infiniteRotationTimeline = gsap.timeline({ repeat: -1, yoyo: false });
    infiniteRotationTimeline.to(group.rotation, { z: -Math.PI * 2, duration: 100, ease: 'none' });
    // Mouse move effect variables
    let mouseX = 0;
    let mouseY = 0;
    const windowHalfX = window.innerWidth / 2;
    const windowHalfY = window.innerHeight / 2;
    let cameraOffsetX = 0;
    let cameraOffsetY = 0;

    // Mouse move event listener
    document.addEventListener('mousemove', onDocumentMouseMove);

    function onDocumentMouseMove(event) {
        mouseX = (event.clientX - windowHalfX) / windowHalfX;
        mouseY = (event.clientY - windowHalfY) / windowHalfY;
    }

    // Separate animation loop for mouse movement
    function animateMouseEffect() {
        requestAnimationFrame(animateMouseEffect);

        // Apply subtle camera movement based on mouse position
        const targetOffsetX = mouseX * 0.1; // Adjust this value to control sensitivity
        const targetOffsetY = -mouseY * 0.1; // Adjust this value to control sensitivity

        cameraOffsetX += (targetOffsetX - cameraOffsetX) * 0.05;
        cameraOffsetY += (targetOffsetY - cameraOffsetY) * 0.05;

        scene.camera.position.x = cameraOffsetX;
        scene.camera.position.y = cameraOffsetY;

    }
   
    animateMouseEffect();
    if (window.innerWidth > 1024) {
    let timeline_hometop = gsap.timeline({
        scrollTrigger: {
            trigger: contact_page,
            scrub: true,
            pin: true,
            start: '-10px top',
            end: "+=200%",
            onEnter: () => {},
            onUpdate: (self) => {
                const scrollProgress = self.progress; // Scroll progress from 0 (start) to 1 (end)
                
                // Update the camera FOV to zoom from initial (1.5x) to final (2.5x) based on scroll
                scene.camera.fov = zoomedInitialFov - (zoomedInitialFov - zoomedFov) * scrollProgress;
                scene.camera.updateProjectionMatrix(); // Update the projection matrix for FOV changes

                // Update object animation based on scroll
                if (objectAction) {
                    const duration = objectAction.getClip().duration;
                    const time = scrollProgress * duration;
                    objectMixer.setTime(time);  // Update animation time according to scroll progress
                }
            },
            onLeaveBack: () => {},
            invalidateOnRefresh: true
        }
    });
    timeline_hometop.to(contact_page, { duration: 4, backgroundColor: '#420000', ease: "none" }, "start")
    .to([contact_top,contact_scrolldown], {autoAlpha:0, duration:1}, "-=2.5")
    .to(form_contant, {autoAlpha:1, duration:1}, "-=1.5")

} else {
    let timeline_hometop = gsap.timeline({
        scrollTrigger: {
            trigger: contact_page,
            scrub: true,
            pin: false,
            start: '-10px top',
            end: "+=200%",
            onEnter: () => {},
            onUpdate: (self) => {
                const scrollProgress = self.progress; // Scroll progress from 0 (start) to 1 (end)
                
                // Update the camera FOV to zoom from initial (1.5x) to final (2.5x) based on scroll
                scene.camera.fov = zoomedInitialFov - (zoomedInitialFov - zoomedFov) * scrollProgress;
                scene.camera.updateProjectionMatrix(); // Update the projection matrix for FOV changes

                // Update object animation based on scroll
                if (objectAction) {
                    const duration = objectAction.getClip().duration;
                    const time = scrollProgress * duration;
                    objectMixer.setTime(time);  // Update animation time according to scroll progress
                }
            },
            onLeaveBack: () => {},
            invalidateOnRefresh: true
        }
    });
    timeline_hometop.to(contact_page, { duration: 4, backgroundColor: '#420000', ease: "none" }, "start")
    .to(form_contant, {autoAlpha:1, duration:1}, "-=1.5")
}

   
    
}

export default LoadedObjectContact;

